export default __webpack_public_path__ + "static/media/8_banner-data-cience.eb6dbb96.jpg";